<template>
  <div class="detail-page">
    <!-- 头部面包屑以及文字，和编辑功能 -->
    <BreadCrumb :data="breadcrumb" :title="'院校详情管理'" />
    <El-button v-if="!isEditting" @click="edit()" class="edit-btn"
      >编辑</El-button
    >
    <!-- 大学详情页基本信息 -->
    <DIV v-show="!isEditting" class="detail-form-information">
      <h2>基本信息</h2>
      <div class="form-content">
        <!-- 左边边图片 -->
        <div>
          <img
            v-if="universityDetail.badge_image"
            :src="universityDetail.badge_image"
            alt=""
            class="form-content-img logo"
          />
          <img
            v-else
            src="../../../../static/image/no-img.png"
            alt=""
            class="form-content-img cover"
          />

          <img
            v-if="universityDetail.cover_image"
            :src="universityDetail.cover_image"
            alt=""
            class="form-content-img cover"
          />
          <img
            v-else
            src="../../../../static/image/no-img.png"
            alt=""
            class="form-content-img cover"
          />
        </div>
        <!-- 右边文字内容 -->
        <ul class="form-content-description">
          <li class="exclusive">
            <h4>中文名</h4>
            <span>{{ universityDetail.chinese_name }}</span>
          </li>
          <li class="exclusive">
            <h4>英文名</h4>
            <span>{{ universityDetail.english_name }}</span>
          </li>

          <li class="exclusive">
            <h4>官网</h4>
            <span v-if="universityDetail.website != null">{{
              universityDetail.website
            }}</span>
            <span v-if="universityDetail.website == null">暂无</span>
          </li>
          <li class="half">
            <h4>地域</h4>
            <div class="area-li-div">
              <span v-if="universityDetail.continent != null">{{
                universityDetail.continent
              }}</span>
              <span v-if="universityDetail.country != null">{{
                universityDetail.country
              }}</span>
              <span v-if="universityDetail.city != null">{{
                universityDetail.city
              }}</span>
              <span
                v-if="
                  universityDetail.continent == null &&
                  universityDetail.country == null &&
                  universityDetail.city == null
                "
                >暂无</span
              >
            </div>
          </li>

          <li class="exclusive">
            <h4>简介</h4>
            <span v-if="universityDetail.introduce != null">{{
              universityDetail.introduce
            }}</span>
            <span v-if="universityDetail.introduce == null">暂无</span>
          </li>
          <li class="half">
            <h4>WUPEN联盟</h4>
            <el-switch
              v-model="universityDetail.wupen_flag"
              active-color="#91CC75"
              inactive-color="#C7C7C7"
              disabled
              :active-value="1"
              :inactive-value="0"
              style="align-self: center"
            >
            </el-switch>
          </li>
          <li class="half">
            <h4>状态</h4>
            <el-switch
              v-model="universityDetail.status"
              active-color="#91CC75"
              inactive-color="#C7C7C7"
              disabled
              :active-value="1"
              :inactive-value="0"
              style="align-self: center"
            >
            </el-switch>
          </li>
        </ul>
      </div>
    </DIV>

    <!-- 修改大学详情基本信息页 -->
    <div v-show="isEditting" class="detail-form-information">
      <h2>修改信息</h2>
      <div class="form-content">
        <!-- 左边边图片 -->
        <div class="imgbox">
          <UploadImage
            :img="universityDetail.badge_image"
            :width="150"
            :height="150"
            @getUploadImage="getUploadLogoImage"
            class="form-content-img"
          ></UploadImage>
          <br /><br /><br />
          <UploadImage
            :img="universityDetail.cover_image"
            :width="220"
            :height="100"
            @getUploadImage="getUploadCoverImage"
            class="form-content-img"
          ></UploadImage>
        </div>
        <!-- 右边文字内容 -->
        <ul class="form-content-description">
          <li class="exclusive">
            <h4>中文名<span>*</span></h4>
            <el-input
              v-model="universityDetail.chinese_name"
              placeholder="请输入中文标题"
            ></el-input>
          </li>
          <li class="exclusive">
            <h4>英文名<span>*</span></h4>
            <el-input
              v-model="universityDetail.english_name"
              placeholder="请输入英文标题"
            ></el-input>
          </li>

          <li class="exclusive">
            <h4 class="choice">简介</h4>
            <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入内容"
              v-model="universityDetail.introduce"
            >
            </el-input>
          </li>
          <li class="half">
            <h4 class="choice">官网</h4>
            <el-input v-model="universityDetail.website"></el-input>
          </li>
          <li class="half">
            <h4 class="choice">地域</h4>
            <el-cascader
              v-model="universityDetail.location"
              :options="addressList"
              @change="saveAddress($event)"
              clearable
            >
              <template slot-scope="{ node, data }">
                <span
                  >{{ data.label != "无" ? data.label : data.children.value }}
                </span>
                <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
              </template>
            </el-cascader>
          </li>
          <li class="half">
            <h4>状态</h4>
            <el-switch
              v-model="universityDetail.status"
              active-color="#91CC75"
              inactive-color="#C7C7C7"
              :active-value="1"
              :inactive-value="0"
              style="align-self: center"
            >
            </el-switch>
          </li>
          <li class="one-third">
            <h4>WUPEN联盟</h4>
            <el-switch
              v-model="universityDetail.wupen_flag"
              active-color="#91CC75"
              inactive-color="#C7C7C7"
              :active-value="1"
              :inactive-value="0"
              style="align-self: center"
            >
            </el-switch>
          </li>
        </ul>
      </div>
    </div>
    <!-- 大学详情页院校标签 -->
    <div class="pc-dataDetail-tags">
      <h2>院校标签</h2>
      <div class="input" v-if="isEditting">
        <keywordsinput
          :maxLen="18"
          v-model="universityDetail.tags"
        ></keywordsinput>
      </div>
      <div v-else class="show">
        <p v-for="(tag, index) in universityDetail.tags" :key="index">
          {{ tag }}
        </p>
      </div>
    </div>

    <!-- 院校图片 -->
    <div class="university-images">
      <h2>院校图片</h2>

      <div class="images-box">
        <UploadImage
          v-if="isEditting"
          :width="230"
          :height="120"
          @getUploadImage="getUploadUniversityImage"
          class="form-content-img upload-image"
        ></UploadImage>
        <div class="image-list">
          <div
            class="image-item"
            v-for="(item, index) in universityDetail.images"
            :key="index"
          >
            <img :src="item" />
            <i
              v-show="isEditting"
              @click="removeImgae(index)"
              class="el-icon-error iconPosi"
            ></i>
          </div>
        </div>
      </div>
    </div>
    <div class="pc-dataDetail-intro">
      <h2>院校介绍</h2>
        <div class="content">
          <h4>详情介绍</h4>

          <el-input
            type="textarea"
            v-if="isEditting"
            :rows="15"
            placeholder="请输入内容"
            v-model="universityDetail.detail_info"
          >
          </el-input>
          <p v-else>
            {{universityDetail.detail_info}}
          </p>
        </div>
    </div>
    <SaveGroup
      :isEditting="isEditting"
      @cancelUpdate="cancelUpdate"
      @save="save"
      @recover="recover"
      @view="view"
      @cancelAdd="cancelAdd"
      @add="add"
    />
  </div>
</template>
<script>
import UploadImage from "../../componentSet/uploadImage.vue";
import UploadImages from "./components/uploadImages.vue";
import BreadCrumb from "../../componentSet/BreadCrumb";
import {
  getUniversities_Api,
  getUniversityAddress_Api,
  updateUniversity_Api,
  createUniversitiy_Api,
} from "../../../apis/university.api";
import SaveGroup from "../../componentSet/SaveGroup.vue";

export default {
  components: {
    SaveGroup,
    UploadImage,
    UploadImages,
    BreadCrumb,
  },
  computed: {
    breadcrumb: function () {
      return [
        {
          name: "首页",
          link: "/admin/main",
        },
        { name: "院校列表", link: "/admin/school" },
        {
          name: `${this.universityDetail.chinese_name}`,
          link: "/admin/schooldetail",
        },
      ];
    },
  },
  data() {
    return {
      isEditting: true,
      universityDetail: {
        id: null,
        topic_id: null,
        topic: { id: "" },
        tags: [],
        images: [],
        chinese_name: "",
      },
      content: "",
      addressList: [],
    };
  },
  mounted() {
    if (this.$route.query.method == "update") {
      this.universityDetail.id = this.$route.query.id;
      this.getUniversityDetail();
    }
    getUniversityAddress_Api().then((res) => {
      this.addressList = res.data;
      console.log(this.addressList);
    });
  },
  methods: {
    returnTranslate(data, flag) {
      flag == 1
        ? (this.universityDetail.detail_info = data)
        : (this.universityDetail.detail_info = data);
      console.log(data);
      console.log(flag);
    },
    getUploadLogoImage(img_url) {
      this.universityDetail.badge_image = img_url;
    },
    getUploadCoverImage(img_url) {
      this.universityDetail.cover_image = img_url;
    },
    removeImgae(index) {
      this.universityDetail.images.splice(index, 1);
    },
    saveAddress(tagData) {
      console.log(tagData);
      this.universityDetail.continent = tagData[0];
      this.universityDetail.country = tagData[1];
      this.universityDetail.city = tagData[3];
    },

    getUploadUniversityImage(img_url) {
      this.universityDetail.images.unshift(img_url);
      console.log(this.universityDetail.images);
      // this.universityDetail.images = img_url;
    },
    getUniversityDetail(hint) {
      getUniversities_Api(this.universityDetail.id).then((res) => {
        hint ? this.$global.success(this, hint) : "";

        this.universityDetail = res.data;
        this.$set(this.universityDetail, 'location', [this.universityDetail.continent, this.universityDetail.country, this.universityDetail.city])
        this.universityDetail.topic == null
        
          ? (this.universityDetail.topic = {})
          : "";

        if (this.universityDetail.topic.id == 5) {
          this.universityDetail.content = this.universityDetail.daily_content;
        }

        if (!this.universityDetail.publish_time) {
          this.universityDetail.publish_time = this.$dtime(new Date()).format(
            "YYYY-MM-DD"
          );
        }
        if (this.universityDetail.position) {
          this.universityDetail.offline = 1;
        }
        console.log(this.universityDetail);
      });
    },
    // save group 回调函数
    cancelUpdate() {
      this.getUniversityDetail("取消成功");
      this.isEditting = false;
    },
    recover() {
      this.getUniversityDetail("恢复成功");
    },
    view() {
      window.open(
        "http://wupen.org/newsEvents/" + this.$route.query.id,
        "_blank"
      );
    },
    cancelAdd() {
      window.close();
    },
    add() {
      let formattedData = this.validateForm(this.universityDetail);
      if (!formattedData) {
        return;
      } else {
        createUniversitiy_Api(formattedData)
          .then((res) => {
            this.universityDetail = res.data;
            this.isEditting = false;
            this.getUniversityDetail();
            this.$router.push({
              path: "/admin/schooldetail",
              query: { id: res.data.id, method: "update" },
            });
            this.$global.success(this, "创建成功！", null);
          })
          .catch((err) => {
            this.$global.error(this, "创建失败！", null);
          });
      }
    },
    save() {
      let formattedData = this.validateForm(this.universityDetail);
      if (!formattedData) {
        return;
      } else {
        updateUniversity_Api(formattedData)
          .then((res) => {
            if (res.code === 205) {
              this.$global.success(this, "更新成功");
              this.getUniversityDetail();
              this.isEditting = false;
            } else {
              this.$global.error(this, "更新失败！", null);
            }
          })
          .catch(() => {
            this.$global.error(this, "更新失败！", null);
          });
      }
    },
    edit() {
      this.isEditting = true;
    },
    validateForm(formData) {
      //表单校验
      if (!formData.chinese_name || !formData.english_name) {
        this.$global.error(this, "请输入中英文标题");
        return false;
      }

      formData.image_list = formData.images;
      formData.university_id = formData.id;
      formData.keywords = formData.tags;
      console.log(formData);
      return formData;
    },
  },
};
</script>
<style lang="scss" scoped>
.university-images {
  @include box-model;
  .images-box {
    overflow-y: hidden;
    overflow-x: auto;
    display: flex;
    height: 170px;
    .upload-image {
      margin-right: 20px;
    }
    .image-list {
      display: flex;
      .image-item {
        position: relative;
        display: inline-block;
        margin-right: 20px;
        img {
          height: 140px;
        }
        .el-icon-error {
          color: $base-color;
          cursor: pointer;
          position: absolute;
          top: 10px;
          right: 10px;
        }
      }
      .image-item:last-child {
        margin-right: 0px;
      }
    }
  }
}
.form-content .cover {
  width: 220px;
  height: 120px;
}
.form-content .logo {
  width: 150px;
  height: 120px;
}

</style>



// WEBPACK FOOTER //
// src/components/admin/university/UniversityListDetail.vue